module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderMobile/OverlayMenus.module.scss");